export default __webpack_public_path__ + "static/media/guild_logo.902ea0a6.png";